import axiosInstance from "api/axiosInstance";
import axios from "axios";
import config from "../../../config";
import { toast } from "react-toastify";

export const botConversationsList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/business/@me/chats", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");

    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};
export const supportConversationsList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/user/@me/chatrooms", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};

export const createAdminChatroom = async (accessToken) => {
  try {
    const response = await axiosInstance.post(
      "/user/@me/chatrooms/create",
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch profile";
  }
};
export const showClientDelet = async (accessToken) => {
  try {
    const response = await axiosInstance.post(
      "/user/@me/deleted_by_user",
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`, // توجه: "Bearer" بود نه "Beareer"
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch deleted chats";
  }
};
export const adminChatroomSendMessage = async ({
  accessToken,
  chatroomId,
  message,
}) => {
  try {
    const response = await axiosInstance.post(
      `/business/chats/send`,
      { message, roomId: chatroomId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          // "Access-Control-Request-Method":"PUT"
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const fetchMessages = async ({ accessToken, chatroomId }) => {
  try {
    const response = await axiosInstance.get(
      `/business/chats/${chatroomId}/messages`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login"; // هدایت مستقیم کاربر به صفحه لاگین
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
// download excel
export const downloadChats = async ({ startDate, endDate, accessToken }) => {
  try {
    const response = await axios.post(
      `${config.apiUrl}/business/chats/download`, // آدرس کامل بک‌اند
      { startDate, endDate },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        responseType: "blob", // مهم برای دریافت فایل
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");

    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};
export const endConversation = async ({ accessToken, roomId }) => {
  try {
    const response = await axiosInstance.patch(
      `/user/@me/chatrooms/${roomId}/end`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;

      if (status === 403) {
        console.warn("دسترسی غیرمجاز");
        window.location.href = "/login";
        return;
      }

      throw {
        statusCode: status,
        message:
          error.response.data?.message ||
          error.response.data?.detail ||
          "خطا در پایان گفتگو",
      };
    } else {
      throw {
        statusCode: 500,
        message: "مشکل شبکه یا عدم دسترسی به سرور",
      };
    }
  }
};
